import { computed, ref } from 'vue'

export const testCasesConnection = ref()
export const issuesConnection = ref()

export const gitlabError = ref()

export const gitlabTestCasesConnectionConfigured = computed(() =>
  testCasesConnection.value &&
  testCasesConnection.value.type === 'gitlab' &&
  testCasesConnection.value.gitlab?.project &&
  testCasesConnection.value.gitlab?.branch
)

export const gitlabIssuesConnectionConfigured = computed(() =>
  issuesConnection.value &&
  issuesConnection.value.type === 'gitlab' &&
  issuesConnection.value.gitlab?.project
)

export const jiraIssuesConnectionConfigured = computed(() =>
  issuesConnection.value &&
  issuesConnection.value.type === 'jira' &&
  issuesConnection.value.jira?.domain &&
  issuesConnection.value.jira?.email &&
  issuesConnection.value.jira?.apiKey
)

export const connectionConfigured = computed(() =>
  (
    testCasesConnection.value &&
    (
      testCasesConnection.value.type === 'local' ||
      gitlabTestCasesConnectionConfigured.value
    )
  ) &&
  (
    issuesConnection.value &&
    (
      issuesConnection.value.type === 'manual' ||
      gitlabIssuesConnectionConfigured.value ||
      (jiraIssuesConnectionConfigured.value && issuesConnection.value.jira?.project)
    )
  )
)

export const connected = ref()
